export default "__VITE_ASSET___4z$yj7u__"